import mixpanel, { Mixpanel } from 'mixpanel-browser';
import { IAnalyticsContext, IAnalyticsProvider } from './AnalyticsProvider';
import { AnalyticsAction } from '../models/AnalyticsAction';
import { Environment } from '../../utils/Environment';

const MOCK_TOKEN = Environment.get<string>('MOCK_MIXPANEL_TOKEN');
const sdkVersion = Environment.get<string>('PRIMER_SDK_VERSION');

export class MixpanelProvider implements IAnalyticsProvider {
  mixpanel: Mixpanel;

  context?: IAnalyticsContext;

  constructor(url: string) {
    const token = MOCK_TOKEN ?? 'TOKEN';
    this.mixpanel = mixpanel.init(token, { api_host: url }, '');
  }

  call(action: AnalyticsAction): void {
    const payload = { ...action.data, ...this.context };

    if (sdkVersion) payload.sdkVersion = sdkVersion;

    mixpanel.track(action.event, payload);
  }

  time(action: AnalyticsAction): void {
    mixpanel.time_event(action.event);
  }

  setContext(context: IAnalyticsContext): void {
    this.context = context;
  }

  setSdkEnvironment(env: string): void {
    if (this.context) this.context.sdkEnvironment = env;
  }

  setPaymentIntent(intent: string): void {
    if (this.context) this.context.paymentIntent = intent;
  }
}
